import React, { Component } from 'react'
import EmailsHeader from '../components/emails/EmailsHeader';

export default class Layout extends Component {

  render() {
    return (
      <div className="App">
        <EmailsHeader {...this.props} />
        <div style={{marginTop: '64px'}}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
